<template>
    <div>
        <p>
            <span class="has-text-weight-bold"
                >{{ $t("plain-text-note.text") }}:
            </span>
            <span>{{ note.text }}</span>
        </p>
    </div>
</template>

<script>
export default {
    name: "plain-text-note",
    props: {
        note: {
            type: Object,
            required: true,
        },
    },
};
</script>